import { SubsectionTitle } from '@sleepstation/components'
import { CopyBulletList, Li } from '@sleepstation/components-copy'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { getParamFromUrl } from '@sleepstation/utils'
import React from 'react'
import { useLoaderData } from 'react-router-dom'
import { getEpworthLevel, getEpworthScoreFormatted } from '../../helpers/quiz'
import PortalPage from '../pages/PortalPage'
import Action from '../pages/portal/PortalQuiz1Results/Action'
import LevelList from '../pages/portal/PortalQuiz1Results/LevelList'
import ConstrainedCopy from '../shared/ConstrainedCopy'
import BreakoutModuleNarrow from '../shared/breakoutModules/BreakoutModuleNarrow'
import ScoreHero from '../shared/heroes/ScoreHero'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PortalQuizAreYouGettingEnoughSleepQuizResultsModule = () => {
  const data = useLoaderData()

  const {
    portal,
    page: { content },
  } = data

  const score = getParamFromUrl(`score`)
  const level = getEpworthLevel(score)

  const actionLink = portal.helpers.getHasActiveLicences()
    ? content.action.link.hasActiveLicences
    : content.action.link.default

  return (
    <PortalPage data={data} showHeader={false} footerMargin={0}>
      <ConstrainedCopy>
        <BreakoutModuleNarrow
          hasGradient={false}
          hasBottomBorder={false}
          marginV={[1, [3, 2]]}
        >
          <ScoreHero
            score={score}
            level={level}
            formatter={getEpworthScoreFormatted}
          />
        </BreakoutModuleNarrow>
        <CopyRenderer htmlAst={content.copy.intro} />
        <SubsectionTitle>What does my score mean?</SubsectionTitle>
        <CopyBulletList>
          <Li>
            If your score is above 10 then you’re not getting enough sleep.
          </Li>
          <Li>
            If it’s above 13, you should get help to improve your sleep as soon
            as possible.
          </Li>
        </CopyBulletList>
        <SubsectionTitle>Scores can be interpreted as follows:</SubsectionTitle>
        <LevelList items={content.levelList.items} />
        <BreakoutModuleNarrow
          hasTopBorder
          hasBottomBorder={false}
          marginV={[
            [2, 0],
            [4, 0],
          ]}
          paddingV={[[1.5, 2], 3]}
        >
          <Action
            level={level}
            link={actionLink}
            dashboardUrl={portal.helpers.getPath(`/portal/dashboard/`)}
          />
        </BreakoutModuleNarrow>
      </ConstrainedCopy>
    </PortalPage>
  )
}

export default PortalQuizAreYouGettingEnoughSleepQuizResultsModule
